var lessVariablesResource = {
    "gridSize": "10px",
    "gridHeight": "10px",
    "gridWidth": "10px",
    "borderRadius": "4px",
   /* "nnDagnyText": "\"NN-Dagny-Text\", Calibri, Corbel, Verdana, sans-serif",
    "nnDagnyDisplay": "\"NN-Dagny-Display\", Calibri, Corbel, Verdana, sans-serif",*/
    "goldmanRegular": "\"GoldmanSans-Regular\", Calibri, Corbel, Verdana, sans-serif",
    "goldmanMedium": "\"GoldmanSans-Medium\", Calibri, Corbel, Verdana, sans-serif",
    "colorText": "#414141",
    "colorWhite": "#ffffff",
    "colorLightOrange": "#ee7f00",
    "colorMediumOrange": "#ea650d",
    "colorDarkOrange": "#e64415",
    "colorPrimary": "#ee7f00",
    "colorBlack": "#000000",
    "colorLightGrey": "#cac7c7",
    "colorMediumGrey": "#999999",
    "colorDarkGrey": "#666666",
    "colorExtraDarkGrey": "#414141",
    "colorExtraLightGrey": "#e5ded9",
    "colorUltraLightGrey": "#f1edeb",
    "colorSuperLightGrey": "#eeeeee",
    "colorLightPurple": "#c6bfe0",
    "colorMediumPurple": "#9c91c6",
    "colorDarkPurple": "#706cb0",
    "colorLightBlue": "#a4ccea",
    "colorMediumBlue": "#7caad6",
    "colorDarkBlue": "#5389c2",
    "colorLightGreen": "#c8cd2e",
    "colorMediumGreen": "#96b439",
    "colorDarkGreen": "#5b9853",
    "colorLighterGrey": "#f4f4f2"
};